import React from "react";

const Header = () => {
  return <div className="header">REDDITIFY</div>;
};

export default Header;
